import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { ServicePlanQuestionnaireItem } from './questionnaire'

// Service plan section questionnaire answer type mapping
export const SERVICE_PLAN_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [ServicePlanQuestionnaireItem.SERVICE_PLAN_PATIENT_TASKS]: QuestionnaireAnswerType.GROUP,
  [ServicePlanQuestionnaireItem.SERVICE_PLAN_PATIENT_TASKS_TASK_INFO]:
    QuestionnaireAnswerType.GROUP,
  [ServicePlanQuestionnaireItem.SERVICE_PLAN_PATIENT_TASKS_TASK_INFO_ID]:
    QuestionnaireAnswerType.INTEGER,
  [ServicePlanQuestionnaireItem.SERVICE_PLAN_PATIENT_TASKS_TASK_INFO_ADL]:
    QuestionnaireAnswerType.STRING,
  [ServicePlanQuestionnaireItem.SERVICE_PLAN_PATIENT_TASKS_TASK_INFO_SERVICE_TYPE]:
    QuestionnaireAnswerType.REFERENCE,
  [ServicePlanQuestionnaireItem.SERVICE_PLAN_PATIENT_TASKS_TASK_INFO_DIRECTIONS]:
    QuestionnaireAnswerType.STRING,
  [ServicePlanQuestionnaireItem.SERVICE_PLAN_PATIENT_TASKS_TASK_INFO_FREQUENCY]:
    QuestionnaireAnswerType.STRING
}
